// Action Types
export const LIST_DEALS_REQUEST = "LIST_DEALS_REQUEST";
export const LIST_DEALS_SUCCESS = "LIST_DEALS_SUCCESS";
export const LIST_DEALS_FAILURE = "LIST_DEALS_FAILURE";

// Action Creators

export const listDealsRequestPlain = ({ userId,accountName,clientName }) => ({
  type: LIST_DEALS_REQUEST,
  payload: { userId,accountName,clientName },
});

export const listDealsRequest = ({userId,accountName,clientName}) => {
  return (dispatch) => {
    dispatch({
      type: LIST_DEALS_REQUEST,
      payload: {userId,accountName,clientName},
    });
  };
};

export const listDealsSuccess = (data) => ({
  type: LIST_DEALS_SUCCESS,
  payload: data,
});

export const listDealsFailure = (error) => ({
  type: LIST_DEALS_FAILURE,
  payload: error,
});